var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2467_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.875C10.7063 1.875 10.875 2.04375 10.875 2.25V9.74531L10.7578 9.59297L7.57031 5.46797C7.46484 5.32969 7.29844 5.25 7.125 5.25C6.95156 5.25 6.7875 5.32969 6.67969 5.46797L4.73438 7.98516L4.01953 6.98438C3.91406 6.83672 3.74531 6.75 3.5625 6.75C3.37969 6.75 3.21094 6.83672 3.10547 6.98672L1.23047 9.61172L1.125 9.75703V9.75V2.25C1.125 2.04375 1.29375 1.875 1.5 1.875H10.5ZM1.5 0.75C0.672656 0.75 0 1.42266 0 2.25V9.75C0 10.5773 0.672656 11.25 1.5 11.25H10.5C11.3273 11.25 12 10.5773 12 9.75V2.25C12 1.42266 11.3273 0.75 10.5 0.75H1.5ZM3.375 5.25C3.52274 5.25 3.66903 5.2209 3.80552 5.16436C3.94201 5.10783 4.06603 5.02496 4.1705 4.9205C4.27496 4.81603 4.35783 4.69201 4.41436 4.55552C4.4709 4.41903 4.5 4.27274 4.5 4.125C4.5 3.97726 4.4709 3.83097 4.41436 3.69448C4.35783 3.55799 4.27496 3.43397 4.1705 3.3295C4.06603 3.22504 3.94201 3.14217 3.80552 3.08564C3.66903 3.0291 3.52274 3 3.375 3C3.22726 3 3.08097 3.0291 2.94448 3.08564C2.80799 3.14217 2.68397 3.22504 2.5795 3.3295C2.47504 3.43397 2.39217 3.55799 2.33564 3.69448C2.2791 3.83097 2.25 3.97726 2.25 4.125C2.25 4.27274 2.2791 4.41903 2.33564 4.55552C2.39217 4.69201 2.47504 4.81603 2.5795 4.9205C2.68397 5.02496 2.80799 5.10783 2.94448 5.16436C3.08097 5.2209 3.22726 5.25 3.375 5.25Z",
    fill: "#890000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2467_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.43fdbf47ee5b83982ca8c7e9a01d8e60.svg";
export { ForwardRef as ReactComponent };